import { useState } from 'react';
import Header from '../../components/Header/Header';
import AdminUsers from '../../components/AdminUsers/AdminUsers';
import AdminDetails from '../../components/AdminDetails/AdminDetails';
import {
  DEFAULT_USER_SEARCH_FIELD,
  USER_SEARCH_OPTIONS,
  isUserSearchField,
} from '../../components/AdminUsers/userSearch';
import './admin.css';

function AdminUsersPage() {
  const [filter, setFilter] = useState<{
    sort: string;
    query: string;
    filterQuery: string;
  }>({ sort: '', query: '', filterQuery: DEFAULT_USER_SEARCH_FIELD });

  const [selectedUser, setSelectedUser] = useState({ id: '', role: '' });

  const handleUserClick = (id: string, role: string) => {
    setSelectedUser({ id, role });
  };

  const search = {
    field: isUserSearchField(filter.filterQuery) ? filter.filterQuery : DEFAULT_USER_SEARCH_FIELD,
    query: filter.query,
  };

  return (
    <>
      <Header filter={filter} setFilter={setFilter} params={USER_SEARCH_OPTIONS} />
      {selectedUser.id ? (
        <AdminDetails selectedUser={selectedUser} onUserClick={handleUserClick} />
      ) : (
        <>
          <div className="admin__container">
            <AdminUsers onUserClick={handleUserClick} search={search} />
          </div>
        </>
      )}
    </>
  );
}

export default AdminUsersPage;
